import { ICompetitionWatchlistPair } from '@kattana-io/common';
import Text from '../../../atoms/Text';
import { toFixed2 } from '../../DexTrades/formatters';

const PairStats = (props: ICompetitionWatchlistPair) => {
  const volume24 = props.volume24 || 0;
  const pnl = props.PNL || 0;
  const tradesNum = props.trades || 0;
  const earnedPoints = props.earnedPoints || 0;
  return (
    <>
      <div className='watchlist__cex__stats watchlist__row__text'>
        <div className='left'>
          <Text size={12} className='text--grey-600 text--weight-500'>
            Your 24h volume:
          </Text>
          <Text size={12} className='text--grey-200 text--weight-500'>
            ${toFixed2(volume24)}
          </Text>
        </div>
        <div className='right'>
          <Text size={12} className='text--grey-600 text--weight-500'>
            PnL:
          </Text>
          <Text
            size={12}
            className={pnl < 0 ? 'text--red-600' : 'text--green-600'}
          >
            {pnl > 0 ? '+' : ''}
            {toFixed2(pnl)}%
          </Text>
        </div>
      </div>
      <div className='watchlist__cex__stats watchlist__row__text'>
        <div className='left'>
          <Text size={12} className='text--grey-600 text--weight-500'>
            Number of trades:
          </Text>
          <Text size={12} className='text--grey-200 text--weight-500'>
            {tradesNum}
          </Text>
        </div>
        <div className='right'>
          <Text size={12} className='text--grey-600 text--weight-500'>
            Earned points:
          </Text>
          <Text size={12} className='text--grey-400'>
            {toFixed2(earnedPoints)}
          </Text>
        </div>
      </div>
    </>
  );
};

export default PairStats;
